import l10n from '../../../shared/strings';
import { resolveChannelLabel } from './showPublishedToChannelToast';
import { LISTING_STATUS } from '../constants/listingStatus';

const RECORD_STATE_LABELS = {
  draft: 'Draft',
  published: 'Published',
};

export const MASTER_SELECTION_CONTEXT = { type: 'master' };

export const createChannelSelectionContext = (channelId, recordState) => ({
  type: 'channel',
  channelId: String(channelId),
  recordState,
});

export const getEntitySelectionContext = (entity) => {
  if (!entity?.type) return null;

  if (entity.type === 'master' || entity.type === 'masterVariant') {
    return MASTER_SELECTION_CONTEXT;
  }

  if (entity.type === 'listing' || entity.type === 'listingVariant') {
    const channelId = entity.channelId || entity.salesChannelId;
    if (!channelId) return null;

    const listingStatus = (entity.listingStatus || '').toUpperCase();
    const recordState = listingStatus === LISTING_STATUS.DRAFT ? 'draft' : 'published';
    return createChannelSelectionContext(channelId, recordState);
  }

  return null;
};

export const resolveContextForEntities = (entries) => {
  if (!entries?.length) return null;
  return getEntitySelectionContext(entries[0]);
};

const contextKey = (context) => {
  if (!context) return '';
  if (context.type === 'master') return 'master';
  return `${context.type}:${context.channelId}:${context.recordState}`;
};

export const isCompatibleContext = (currentContext, incomingContext) => (
  contextKey(currentContext) === contextKey(incomingContext)
);

export const isMasterSelectionContext = (context) => context?.type === 'master';

export const isDraftSelectionContext = (context) => (
  context?.type === 'channel' && context.recordState === 'draft' && Boolean(context.channelId)
);

export const formatSelectionContextLabel = (context, salesChannels = []) => {
  if (!context) return '';

  if (context.type === 'master') {
    return l10n.SEARCH.productLayer.master;
  }

  const channelLabel = resolveChannelLabel(context.channelId, salesChannels);
  const recordLabel = RECORD_STATE_LABELS[context.recordState] || context.recordState;

  return `${channelLabel} · ${recordLabel}`;
};
